import Mock from 'mockjs'
import loginAPI from './login_mock'

// 登录相关
Mock.mock('/auth/accountLogin/w/v1', 'post', loginAPI.getUserInfo)
Mock.mock('/auth/logout', 'post', loginAPI.logout)
Mock.mock('/auth/getMsgCode', 'get', loginAPI.getMsgCode)
Mock.mock('/auth/loginByCode', 'get', loginAPI.loginByCode)
Mock.mock('/auth/setPassword', 'post', loginAPI.setPassword)